"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgProcess(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M7.9947,4.70711V3.27977l-1.101-.2221a3.02724,3.02724,0,0,0-.1881-.45135l.62094-.93492L6.31756.66211,5.38484,1.282a3.02246,3.02246,0,0,0-.45617-.1907L4.70816-.00255H3.28127l-.2205,1.09382a3.02237,3.02237,0,0,0-.45859.19185L1.67339.66586.66444,1.67512l.619.932a3.02506,3.02506,0,0,0-.19021.4574L0,3.285V4.71238l1.09954.22179a3.02849,3.02849,0,0,0,.1895.45176l-.62085.93482,1.009,1.0093L2.617,6.70547a3.02278,3.02278,0,0,0,.44715.186L3.28654,7.9947H4.71342l.22327-1.10746a3.02329,3.02329,0,0,0,.44424-.18586l.94035.62491L7.33023,6.317l-.625-.94112a3.0233,3.0233,0,0,0,.18633-.44627Zm-4,.807A1.52339,1.52339,0,1,1,5.5176,3.99073,1.52314,1.52314,0,0,1,3.9947,5.51411Zm12.00267,4.1097-.71882-1.73594-1.45093.28473a3.98392,3.98392,0,0,0-.45608-.45416l.28436-1.45-1.73538-.71907L11.0983,6.77332a3.97627,3.97627,0,0,0-.65084-.002l-.819-1.21919L7.893,6.27113l.28267,1.44143a3.98088,3.98088,0,0,0-.46112.46442L6.27413,7.89431,5.55532,9.63022l1.22218.82158a3.98277,3.98277,0,0,0-.001.65215l-1.21853.8191L6.27681,13.659l1.449-.28435a3.98651,3.98651,0,0,0,.458.45394l-.2843,1.4498,1.73538.71907.82848-1.23322a3.976,3.976,0,0,0,.63748.00083l.82614,1.22972,1.73539-.71905-.28619-1.4594a3.98072,3.98072,0,0,0,.44668-.44992l1.45838.28616L16,11.91665,14.76588,11.087a3.9817,3.9817,0,0,0,.00188-.63667ZM11.539,12.621a2.00531,2.00531,0,1,1,1.085-2.62018A2.00453,2.00453,0,0,1,11.539,12.621Z' })));
}
exports.default = SvgProcess;
